import { render, staticRenderFns } from "./DoxSelect.vue?vue&type=template&id=7142072c&scoped=true&"
import script from "./DoxSelect.vue?vue&type=script&lang=js&"
export * from "./DoxSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7142072c",
  null
  
)

export default component.exports